import { render, staticRenderFns } from "./network-quota.vue?vue&type=template&id=61cd17ef&scoped=true&"
import script from "./network-quota.vue?vue&type=script&lang=js&"
export * from "./network-quota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cd17ef",
  null
  
)

export default component.exports